/** The client-side refinement values (strings; '' = off) — mirrors load-hub's Row-2 numeric filters. */
export interface BoxTruckRefinements {
    minMi: string
    maxMi: string
    minR: string
    minT: string
    minWeight: string
    maxWeight: string
    /** Contact-info requirement: '' = all, 'email' = only loads with a broker email, 'phone' = only with a phone. */
    contact: string
}

export const EMPTY_REFINEMENTS: BoxTruckRefinements = { minMi: '', maxMi: '', minR: '', minT: '', minWeight: '', maxWeight: '', contact: '' }

/** One labelled compact numeric input — label inside the pill, digits + one decimal point only. */
const NumBox = ({ label, title, value, onChange }: { label: string; title: string; value: string; onChange: (v: string) => void }) => (
    // <label> so clicking the pill ANYWHERE (the text label included) focuses the input — safe here
    // because the input is the only control inside.
    <label className="flex h-8 cursor-text items-center rounded-lg bg-surface px-2 shadow-field focus-within:ring-2 focus-within:ring-accent">
        <span className="pr-1.5 text-[10px] font-medium text-foreground-muted">{label}</span>
        <input
            type="text"
            inputMode="decimal"
            value={value}
            onChange={(e) => {
                const v = e.target.value
                if (v === '' || /^\d*\.?\d*$/.test(v)) onChange(v)
            }}
            aria-label={title}
            title={title}
            className="h-full w-14 bg-transparent text-xs font-medium tabular-nums text-foreground outline-none"
        />
    </label>
)

/**
 * Compact refinement row for the box-truck boards — trip min/max miles, applied instantly over the loaded
 * rows.
 *
 * The narrower ones — min rate, min RPM, min/max weight, load age, required contact — moved into the
 * Advanced Filters panel so the default board stays readable.
 */
export const BoxTruckRefinementBar = ({ values, onChange }: { values: BoxTruckRefinements; onChange: (patch: Partial<BoxTruckRefinements>) => void }) => {
    return (
        <div className="flex flex-wrap items-center gap-2">
            <NumBox label="Min mi" title="Minimum trip miles" value={values.minMi} onChange={(v) => onChange({ minMi: v })} />
            <NumBox label="Max mi" title="Maximum trip miles" value={values.maxMi} onChange={(v) => onChange({ maxMi: v })} />
        </div>
    )
}
